import Util from "@/js/common/Util";
import React, { CSSProperties } from "react";
import { NumericFormat } from "react-number-format";
import Span from "../Span";

interface NumberTextBoxProps {
    value: string
    onChange?: Function
    onKeyUp?: Function
    className?: string
    thousandsGroupStyle?: 'thousand' | 'lakh' | 'wan' | 'none'
    thousandSeparator?: string
    maxLength?: number
    decimalScale?: number
    inputClass?: string
    unitClass?: string
    unitText?: string
    disabled?: boolean
    placeholder?: string
    background?: string
    fontSize?: number
    fontFamily?: string
    letterSpacing?: number
    color?: string
    unitTextFontSize?: number
    unitTextFontFamily?: string
    unitTextLetterSpacing?: number
    unitTextColor?: string
    borderColor?: string
    borderOnColor?: string
    style?: CSSProperties
}

const NumberTextBox = ({value, onChange, onKeyUp, className, thousandsGroupStyle, thousandSeparator, maxLength, decimalScale, inputClass, unitClass, unitText, disabled, placeholder, background, fontSize, fontFamily, letterSpacing, color, unitTextFontSize, unitTextFontFamily, unitTextLetterSpacing, unitTextColor, borderOnColor, borderColor, style}: NumberTextBoxProps) => {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const [focusState, setFocusState] = React.useState<boolean>(false);
    const [hoverState, setHoverState] = React.useState<boolean>(false);

    let calcMaxLength = maxLength;
    if (maxLength && value) {
        calcMaxLength = maxLength + value.toString().split(',').length -1 + value.toString().split('.').length -1;
    }

    return (
        <div
            className={"dpFlx aiC bsBdb " + className}
            style={{
                ...style,
                borderColor: (focusState || hoverState ? (Util.isEmpty(borderOnColor) ? "#2b2b2b" : borderOnColor) : (Util.isEmpty(borderColor) ? "#dddddd" : borderColor)),
            }}
            onMouseOver={() => setHoverState(true)}
            onMouseOut={() => setHoverState(false)}
            onClick={() => inputRef.current?.focus()}
        >
            <NumericFormat
                style={{
                    fontSize: fontSize,
                    fontFamily: fontFamily,
                    letterSpacing: letterSpacing,
                    color: color,
                    fontVariant: "tabular-nums",
                    background: "transparent"
                }}
                getInputRef={inputRef}
                onFocus={() => setFocusState(true)}
                onBlur={() => setFocusState(false)}
                thousandsGroupStyle={thousandsGroupStyle}
                thousandSeparator={thousandSeparator}
                maxLength={calcMaxLength}
                decimalScale={decimalScale}
                max={10}
                value={value}
                onChange={(e) => {
                    if (onChange === undefined) {
                        return;
                    }
                    onChange(e.target.value)
                }}
                onKeyUp={(e: any) => {
                    if (onKeyUp === undefined || !e.target.value) {
                        return;
                    }
                    onKeyUp(e.target.value)
                }}
                className={"bdN bsBdb olN w100p h100p " + inputClass}
                disabled={disabled}
                placeholder={placeholder}
            />
            {Util.isNotEmpty(unitText) && Util.isNotEmpty(value) ?
                <Span
                    fontSize={unitTextFontSize}
                    fontFamily={unitTextFontFamily}
                    letterSpacing={unitTextLetterSpacing}
                    color={unitTextColor}
                >
                    {unitText}
                </Span>
            : <></>}
        </div>
    )
}
export default NumberTextBox;